<div class="top-section" [ngClass]="{'with-tab': activeEntities().length > 1}">
    <div class="flex items-center">
        <app-svg name="hamburger" class="common-hamburger" (click)="ss.toggleSidebar()" role="button"
            [color]="ss.theme().color8" *ngIf="!cc.isNarrowScreen()"></app-svg>
        <h4 class="heading mb-0">{{ activeEntities().length === 0 ? ss.t('hamburgerTray_featuresTrash') :
            config[activeEntity()]['name'] }}</h4>
    </div>
    <div class="flex items-center gap-3">
        <app-notification [iconColor]="cc.isNarrowScreen() ? ss.theme().color12 : null"></app-notification>
        <app-svg name="close" role="button" (click)="navigateToToday()"
            [color]="cc.isNarrowScreen() ? ss.theme().color12 : ss.theme().color8"></app-svg>
    </div>
</div>

<mat-tab-group class="trashes-tab" (selectedTabChange)="setTab($event.index)" disableRipple
    [ngClass]="{ 'hide-header': activeEntities().length <= 1 }" *ngIf="activeEntities().length > 0">
    <mat-tab *ngFor="let entity of activeEntities(); let i = index;">
        <ng-template mat-tab-label>
            <app-svg [name]="config[entity]['icon']" [color]="ss.theme().color8" style="height: 18px;"></app-svg>
        </ng-template>

        <app-todo-trash-tab *ngIf="entity === 'todo'"></app-todo-trash-tab>

        <app-list-trash-tab *ngIf="entity === 'list'"></app-list-trash-tab>

        <app-note-trash-tab *ngIf="entity === 'note'"></app-note-trash-tab>

        <app-habit-trash-tab *ngIf="entity === 'habit'"></app-habit-trash-tab>

        <app-journal-trash-tab *ngIf="entity === 'journal'"></app-journal-trash-tab>

        <app-money-tracker-trash-tab *ngIf="entity === 'moneyTracker'"></app-money-tracker-trash-tab>

        <app-focus-trash-tab *ngIf="entity === 'focus'"></app-focus-trash-tab>
    </mat-tab>
</mat-tab-group>

<div class="body-section" *ngIf="activeEntities().length === 0">
    <!-- <div class="no-result-block h-full flex items-center justify-center flex-col">
        <app-svg name="planPlaceholder" [color]="ss.theme().color1"></app-svg>
        <p class="text-16-400 color-8 mb-0 ri-pt-4">{{ ss.t('trash_emptyScreenContent') }}</p>
    </div> -->
    <app-no-result-block [imagePlaceholder]="'trashPlaceholder'" [placeholder]="'trash_emptyScreenContent'"
        [showQuickGuide]="false"></app-no-result-block>
</div>